module.exports = __webpack_public_path__ + "static/tonys-01-cd4730a63209a902d6f52d7db878a762.png";